module.exports = __webpack_public_path__ + "img/epl.2bdd44f0.jpg";